export default __webpack_public_path__ + "static/media/gift.60d19208.svg";